import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  GroupValidationRequest,
  DocumentResponse,

  GroupedQuestionsResponseDTO,
  QuestionAnswerBatchRequestDTO,
  EclaircissementDraftResponseDTO,
  DemandeListResponseDTO,
  DemandeWithTaskDTO,
  EclaircissementStartResponseDTO,
  IResponsePaginate,
  downloadEclaircissementDTO,
} from '@/types';

@Injectable({
  providedIn: 'root',
})
export class ClarificationService {
  BASEURL = `${environment.api.eclaircissementUrl}`;
  FLOWABLEURL = `${environment.api.eclaircissementUrl}/flowable`;
  FLOWABLEADDITIVSURL = `${environment.api.eclaircissementUrl}/flowable/tasks`;
  httpClient = inject(HttpClient);

  private questionsTasksCache$?: Observable<any>;

  getQuestionsTasks(params?: { page?: number; size?: number }): Observable<any> {
    const httpParams = new HttpParams();
    if (params?.page !== undefined) {
      httpParams.set('page', params.page.toString());
    }
    if (params?.size !== undefined) {
      httpParams.set('size', params.size.toString());
    }
    return this.httpClient.get<any>(`${this.FLOWABLEADDITIVSURL}`, {
      params: httpParams,
    });
  }

  // Method to clear cache when needed (e.g., after updates)
  clearQuestionsTasksCache(): void {
  }

  // Method to clear user tasks cache when needed (e.g., after updates)
  clearUserTasksCache(): void {
  }

  validateCpmpFiltration(additifId: number, valide: boolean, comment?: string, haveReport?: boolean, dateReport?: string|null): Observable<any> {
    const formData = new FormData();
    formData.append('validate', valide.toString());
    formData.append('comment', comment || '');
    if (haveReport !== undefined) formData.append('haveReport', String(haveReport));
    if (dateReport) formData.append('dateReport', dateReport);

    return this.httpClient.post<any>(`${this.BASEURL}/flowable/tasks/additif/${additifId}/validate_filtrage_cncmp`, formData);
  }

  getQuestionsForRedacteur(): Observable<GroupedQuestionsResponseDTO> {
    return this.httpClient.get<GroupedQuestionsResponseDTO>(`${this.BASEURL}/questions/redacteur`);
  }

  answerQuestionsBatch(requestDTOs: QuestionAnswerBatchRequestDTO[]): Observable<GroupedQuestionsResponseDTO> {
    return this.httpClient.put<GroupedQuestionsResponseDTO>(`${this.BASEURL}/questions/answer-batch`, requestDTOs);
  }

  createDemandeEclaircissemnt(questionIds: number[]): Observable<EclaircissementDraftResponseDTO> {
    return this.httpClient.post<EclaircissementDraftResponseDTO>(`${this.BASEURL}/eclaircissements/demande-eclaircissemnt/brouillon`, questionIds);
  }

  getPaginatedDemandes(params?: { page?: number; size?: number; search?: string; sort?: string }): Observable<IResponsePaginate<DemandeListResponseDTO>> {
    let httpParams = new HttpParams();
    if (params?.page !== undefined) httpParams = httpParams.set('page', params.page.toString());
    if (params?.size !== undefined) httpParams = httpParams.set('size', params.size.toString());
    if (params?.search) httpParams = httpParams.set('search', params.search);
    if (params?.sort) httpParams = httpParams.set('sort', params.sort);

    return this.httpClient.get<IResponsePaginate<DemandeListResponseDTO>>(`${this.BASEURL}/eclaircissements/paginated`, { params: httpParams });
  }

  getDemandeWithTask(demandeId: number): Observable<DemandeWithTaskDTO> {
    return this.httpClient.get<DemandeWithTaskDTO>(`${this.FLOWABLEURL}/demande/${demandeId}/with-task`);
  }

  startDemande(demandeId: number): Observable<EclaircissementStartResponseDTO> {
    return this.httpClient.post<EclaircissementStartResponseDTO>(`${this.BASEURL}/eclaircissements/start-demandes/${demandeId}`, {});
  }
  generateDemandeModels(request: downloadEclaircissementDTO): Observable<DocumentResponse[]> {
    return this.httpClient.post<DocumentResponse[]>(`${this.BASEURL}/eclaircissement/documents/generate-models`, request);
  }

  generateDemandeModelsPdf(request: { id: string }): Observable<Blob> {
    return this.httpClient.post(`${this.BASEURL}/eclaircissement/documents/generate-models-pdf`, request, { responseType: 'blob' });
  }

  uploadDemandeDocument(demandeId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.post<any>(`${this.BASEURL}/eclaircissements/upload/demandes/${demandeId}`, formData);
  }

  validateTaskWithModel(taskId: string, validate: boolean, comment: string, haveReport?: boolean, dateReport?: string|null, file?: File): Observable<any> {
    const formData = new FormData();
    const request = {
      taskId,
      validate,
      comment,
      haveReport,
      dateReport,
    };
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    if (file) {
      formData.append('modelEclaircissementFile', file);
    }
    const formData2 = new FormData();
    formData2.append('taskId', taskId);
    formData2.append('validate', String(validate));
    formData2.append('comment', comment || '');
    if (haveReport !== undefined) formData2.append('haveReport', String(haveReport));
    if (dateReport) formData2.append('dateReport', dateReport);
    if (file) {
      formData2.append('modelEclaircissementFile', file);
    }

    return this.httpClient.post<any>(`${environment.api.eclaircissementUrl}/flowable/tasks/${taskId}/validate_with_model`, formData2);
  }
  getDemandeDocument(demandeId: number): Observable<Blob> {
    return this.httpClient.get(`${this.BASEURL}/eclaircissements/demandes/${demandeId}/document`, { responseType: 'blob' });
  }

  downloadModelDemande(alfrescoId: string): Observable<DocumentResponse> {
    const url = `${environment.api.paramsUrl}/docs/download/model-demande`;
    return this.httpClient.post<DocumentResponse>(url, { id: alfrescoId });
  }

  downloadDemandeWord(alfrescoId: string): Observable<DocumentResponse> {
    const url = `${environment.api.paramsUrl}/docs/download/demande`;
    return this.httpClient.post<DocumentResponse>(url, { id: alfrescoId });
  }
  validateTask(taskId: string, request: GroupValidationRequest, file?: File): Observable<any> {
    const formData = new FormData();
    if (request.taskId) formData.append('taskId', request.taskId);
    if (request.validate !== undefined) formData.append('validate', String(request.validate));
    if (request.comment) formData.append('comment', request.comment);
    if (request.comId) formData.append('comId', String(request.comId));
    if (request.cncmpDecision !== undefined) formData.append('cncmpDecision', String(request.cncmpDecision));
    if (request.reunionId) formData.append('reunionId', String(request.reunionId));
    if (request.fromMeeting !== undefined) formData.append('fromMeeting', String(request.fromMeeting));
    if (request.assigneeUserId) formData.append('assigneeUserId', request.assigneeUserId);
    if (request.avis) formData.append('avis', request.avis);
    if (request.docIdNote) formData.append('docIdNote', String(request.docIdNote));
    if (request.dateLimiteReception) formData.append('dateLimiteReception', request.dateLimiteReception);
    if (request.dateOuverture) formData.append('dateOuverture', request.dateOuverture);
    if (request.haveReport !== undefined) formData.append('haveReport', String(request.haveReport));
    if (request.dateReport) formData.append('dateReport', request.dateReport);
    if (file) {
      formData.append('file', file);
    }

    return this.httpClient.post<any>(`${environment.api.eclaircissementUrl}/flowable/tasks/${taskId}/validate`, formData);
  }

  validateAvisNoteRapporteurWithFile(taskId: string, request: GroupValidationRequest, noteFile?: File): Observable<any> {
    const formData = new FormData();
    formData.append('taskId', taskId);
    if (request.validate !== undefined) formData.append('validate', String(request.validate));
    if (request.comment) formData.append('comment', request.comment);
    if (request.comId) formData.append('comId', String(request.comId));
    if (request.cncmpDecision !== undefined) formData.append('cncmpDecision', String(request.cncmpDecision));
    if (request.reunionId) formData.append('reunionId', String(request.reunionId));
    if (request.fromMeeting !== undefined) formData.append('fromMeeting', String(request.fromMeeting));
    if (request.assigneeUserId) formData.append('assigneeUserId', request.assigneeUserId);
    if (request.avis) formData.append('avis', request.avis);
    if (request.docIdNote) formData.append('docIdNote', String(request.docIdNote));
    if (request.haveReport !== undefined) formData.append('haveReport', String(request.haveReport));
    if (request.dateReport) formData.append('dateReport', request.dateReport);
    if (noteFile) {
      formData.append('noteFile', noteFile);
    }

    return this.httpClient.post<any>(`${environment.api.eclaircissementUrl}/flowable/tasks/${taskId}/validate_avis_note_rapporteur`, formData);
  }
}
